import { render, staticRenderFns } from "./ShareSlideNote.vue?vue&type=template&id=0cc433b3&"
import script from "./ShareSlideNote.vue?vue&type=script&lang=js&"
export * from "./ShareSlideNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports